{
  "flaggedStacksPresenter": {
    "title": "Markierte Stapel",
    "columns": {
      "id": "ID",
      "hangar": "Hangar",
      "date": "Datum"
    },
    "buttons": {
      "view": "Zeigen"
    }
  }
}
